interface LoaderProps {
  text?: string;
  message?: string;
  style?: React.CSSProperties;
  isInnerSpinner?: boolean;
}

export default function Loader({
  text = 'Loading',
  message,
  style = {},
  isInnerSpinner = false,
}: LoaderProps) {
  const label = message ?? text;
  const content = (
    <div className="home-blog-loader">
      <img src="/static/images/s-disgenet-loader.svg" alt={label} className="home-blog-loader-img" />
      <p className="home-blog-loader-text">{label}</p>
    </div>
  );

  if (isInnerSpinner) {
    return (
      <div className="flex items-center justify-center" style={style}>
        {content}
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9999,
        ...style,
      }}
    >
      {content}
    </div>
  );
}
